import language from "./../../src/common/i18n/it_IT.json";

const dictionary = language;

// If needed, you can add or override translations here for the current client
dictionary.notifications_title = "oops";

export default dictionary;



// WEBPACK FOOTER //
// ./clients/rcs-gds/dictionary.js